import { Events as EventsTypes } from "@timesheets/webapp-support";

const Events: Record<string, any> = Object.assign({ _name: "events" }, EventsTypes);

Events.Action = Events._name + "-action";
Events.Created = Events._name + "-created";

Events.Failed = Events._name + "-failed";
Events.Hidden = Events._name + "-hidden";
Events.HoursChange = Events._name + "-hoursChange";
Events.LogoChanged = Events._name + "-logoChanged";
Events.Succeeded = Events._name + "-succeeded";
Events.SubmitDisabled = Events._name + "-submitDisabled";

export default Events;
